export default __webpack_public_path__ + "1459a0e695786e38d26e5c095bcdf067.svg";